export default __webpack_public_path__ + "static/ian2-3f870c58e957d61f6afa6566a1521542.jpg";